<template>
  <v-dialog :value="value" class="comparison-period-dialog" width="50%" persistent>
    <v-card class="pa-0">
      <v-card-title>Period {{ periodNumber }}</v-card-title>
      <v-card-text class="black--text">
        <v-row class="align-center">
          <v-col cols="12">
            <elwrapper label="Arrival">
              <div class="d-flex flex-row align-center">
                <year-picker v-model="period.startYear" @input="updateStartDate" />
                <month-picker class="ml-2" v-model="period.startMonth" @input="updateStartDate" />
                <day-picker class="ml-2" :month="period.startMonth" v-model="period.startDay" @input="updateStartDate" />
              </div>
            </elwrapper>
          </v-col>
        </v-row>
        <v-row class="align-center">
          <v-col cols="12">
            <elwrapper label="Departure">
              <div class="d-flex flex-row align-center">
                <year-picker :value="period.endYear" disabled hideClear />
                <month-picker class="ml-2" :value="period.endMonth" disabled hideClear />
                <day-picker class="ml-2" :month="period.endMonth" :value="period.endDay" disabled hideClear />
              </div>
            </elwrapper>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <g-button label="Cancel" @onclick="onCancel" />
        <div class="flex-grow-1"></div>
        <g-button label="OK" @onclick="onOK" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    data: {
      type: Object,
      default: () => ({}),
    },
    nights: [Number, String],
    periodNumber: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      period: this.createEmptyPeriod(),
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(newValue) {
        if (!newValue) return;
        this.period = {
          ...this.createEmptyPeriod(),
          ...(this.data.period || {}),
        };
        this.recalculateEndDate();
      },
    },
    nights() {
      if (!this.value) return;
      this.recalculateEndDate();
    },
  },
  methods: {
    createEmptyPeriod() {
      return {
        startYear: null,
        startMonth: null,
        startDay: null,
        endYear: null,
        endMonth: null,
        endDay: null,
      };
    },
    updateStartDate() {
      if (!this.period.startMonth) this.period.startDay = null;
      this.recalculateEndDate();
    },
    recalculateEndDate() {
      const { startYear, startMonth, startDay } = this.period;
      const nights = this.nights;

      if (!startYear || !startMonth || !startDay || nights === null || nights === undefined || nights === "") {
        Object.assign(this.period, { endYear: null, endMonth: null, endDay: null });
        return;
      }

      const startDate = new Date(Number(startYear), Number(startMonth) - 1, Number(startDay));
      if (Number.isNaN(startDate.getTime())) return;

      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + Number(nights));

      Object.assign(this.period, {
        endYear: endDate.getFullYear().toString(),
        endMonth: endDate.getMonth() + 1,
        endDay: endDate.getDate(),
      });
    },
    onCancel() {
      this.$emit("input", false);
    },
    onOK() {
      this.$emit("update", { ...this.data, period: { ...this.period } });
      this.$emit("input", false);
    },
  },
};
</script>
